import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getAllOrders } from '../../../../../services/orderAPI';

// Switched to upfront plan but the remaining balance hasn't been paid yet.
// Driven by switchedToFullPayment rather than mandateStatus, matching mobile.
export const isAwaitingUpfrontBalance = (order) =>
  order?.switchedToFullPayment === true &&
  order?.upfrontPlan?.balancePaymentStatus !== 'completed' &&
  order?.paymentSummary?.is_fully_paid !== true &&
  !['cancelled', 'refunded'].includes(order?.orderStatus?.toLowerCase());

export const useOrders = () => {
  const queryClient = useQueryClient();
  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: ['allOrders'],
    queryFn: getAllOrders,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 30_000,
  });

  const invalidateOrders = () => {
    queryClient.invalidateQueries({ queryKey: ['allOrders'] });
  };

  const allOrders = data?.orders || [];

  const onGoingOrders = allOrders.filter(
    (order) =>
      ['active'].includes(order.orderStatus) && !isAwaitingUpfrontBalance(order)
  );

  const completedOrders = allOrders.filter(
    (order) =>
      ['completed'].includes(order.orderStatus) ||
      order.fullPaymentStatus === 'success' ||
      order?.paymentSummary?.is_fully_paid === true
  );

  const cancelledOrders = allOrders.filter(
    (order) =>
      ['cancelled'].includes(order.orderStatus) ||
      order.fullPaymentStatus === 'cancelled'
  );

  const pendingOrders = allOrders.filter(
    (order) =>
      (isAwaitingUpfrontBalance(order) ||
        [
          'pending',
          'awaiting',
          'rejected',
          'failed',
          'ongoing',
          'initiated',
          'switched_to_upfront',
        ].includes(order?.mandateStatus)) &&
      order?.paymentSummary?.total_amount_paid !== 0 &&
      order?.paymentSummary?.is_fully_paid !== true
  );

  return {
    allOrders,
    onGoingOrders,
    completedOrders,
    cancelledOrders,
    pendingOrders,
    isLoading,
    isFetching,
    isError,
    invalidateOrders,
  };
};
